exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt10{\n  margin-top: 10px;\n}\n", ""]);

// exports
